export const SERVICE_ORDER_ATTACHMENT_ACCEPT = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".zip",
  ".txt",
].join(",");

const MAX_ATTACHMENT_SIZE_BYTES = 2 * 1024 * 1024;
const MAX_ATTACHMENT_SIZE_LABEL = "2MB";

const ALLOWED_ATTACHMENT_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "zip",
  "txt",
]);

const ALLOWED_ATTACHMENT_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip",
  "application/x-zip-compressed",
  "application/octet-stream",
  "text/plain",
]);

export function validateServiceOrderAttachment(file) {
  if (!file) {
    return "";
  }

  const extension = String(file.name || "").split(".").pop()?.toLowerCase() || "";
  const typeAllowed = file.type ? ALLOWED_ATTACHMENT_TYPES.has(file.type) : true;
  const extensionAllowed = ALLOWED_ATTACHMENT_EXTENSIONS.has(extension);

  if (!typeAllowed || !extensionAllowed) {
    return "Only JPG, PNG, GIF, PDF, DOC, DOCX, XLS, XLSX, ZIP, and TXT files are allowed.";
  }

  if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return `File must be smaller than ${MAX_ATTACHMENT_SIZE_LABEL}.`;
  }

  return "";
}
